import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { ChapterListItem } from 'components';
import CopiedContentListCard from 'components/CopiedContentMenu/CopiedContentListCard';
import { OfflineValuesContext } from 'contexts';
import { sortByIndexOfType } from 'utilities';
import { areListItemsEqual } from 'utilities/sideNavUtils';

const useStyles = makeStyles((theme) => ({
  listItem: {
    borderBottom: `solid 1px ${theme.palette.grey[300]}`, // #E5E5E5
    marginLeft: theme.spacing(2),
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
}));

const arePropsEqual = (prevProps, nextProps) => {
  if (prevProps.isOffline !== nextProps.isOffline) {
    return false;
  }

  const itemPropsToCompare = ['snippet'];

  return areListItemsEqual(
    prevProps.children,
    nextProps.children,
    itemPropsToCompare,
  );
};

const CopiedContentListItem = memo(
  ({ children, isOffline, topLevelMarker, ...props }) => {
    const classes = useStyles();
    const { markersDownloaded } = useContext(OfflineValuesContext);
    const label = topLevelMarker?.label ?? 'No Chapter';
    const index = topLevelMarker?.index ?? 'no-chapter';
    const chapterTitle = (
      <div className={'noTranslate'}>{`${label} (${children.length})`}</div>
    );
    const sortedChildren = sortByIndexOfType(children, 'page');

    return (
      <ChapterListItem
        ariaLabelChapterTitle={label}
        id={`copied-content-${index}`}
        isNavItem={false}
        title={chapterTitle}
        {...props}
      >
        {Boolean(sortedChildren?.length) &&
          sortedChildren.map((contentItem) => {
            return (
              <li
                className={classes.listItem}
                key={`copied-content-card-${contentItem.id}`}
              >
                <CopiedContentListCard
                  contentItem={contentItem}
                  isSnippetLinkAvailable={
                    !isOffline || markersDownloaded?.has(contentItem?.marker)
                  }
                />
              </li>
            );
          })}
      </ChapterListItem>
    );
  },
  arePropsEqual,
);

CopiedContentListItem.propTypes = {
  children: PropTypes.array.isRequired,
  isOffline: PropTypes.bool,
  topLevelMarker: PropTypes.object,
};

export default CopiedContentListItem;
